(function () {
  const modal = document.getElementById('sk-confirmation-modal');
  if (!modal) return;

  const titleEl = modal.querySelector('.sk-confirmation-modal__title');
  const messageEl = modal.querySelector('.sk-confirmation-modal__message');
  const detailEl = modal.querySelector('.sk-confirmation-modal__detail');
  const ctaEl = modal.querySelector('[data-confirmation-cta]');

  ctaEl.addEventListener('click', function (e) {
    if (ctaEl.hasAttribute('data-close')) {
      e.preventDefault();
      Woolman?.ModalsAndDrawers?.closeModalOrDrawer('sk-confirmation-modal');
    }
  });

  function showModal(opts) {
    modal.dataset.type = opts.type;

    titleEl.textContent = opts.title || '';
    messageEl.textContent = '';

    if (opts.type === 'success' && opts.reference) {
      const i18n = window.SK?.i18n || {};
      const refSpan = document.createElement('span');
      refSpan.className = 'sk-confirmation-modal__reference';
      refSpan.textContent = (i18n.modalReference || 'Reference:') + ' ' + opts.reference;
      messageEl.appendChild(refSpan);
      messageEl.appendChild(document.createTextNode(' ' + (opts.message || '')));
    } else {
      messageEl.textContent = opts.message || '';
    }

    detailEl.textContent = opts.detail || '';
    ctaEl.textContent = opts.ctaText || '';

    if (opts.ctaUrl) {
      ctaEl.href = opts.ctaUrl;
      if (ctaEl.hasAttribute('data-close')) ctaEl.removeAttribute('data-close');
    } else {
      ctaEl.href = '#';
      if (!ctaEl.hasAttribute('data-close')) ctaEl.setAttribute('data-close', '');
    }

    if (Woolman?.ModalsAndDrawers?.showModalOrDrawer) {
      Woolman.ModalsAndDrawers.showModalOrDrawer('sk-confirmation-modal');
    }
  }

  window.SK = window.SK || {};
  window.SK.showConfirmationModal = showModal;
  window.SK.showErrorModal = function (detail) {
    const i18n = window.SK?.i18n || {};
    showModal({
      type: 'error',
      title: i18n.modalErrorTitle || 'Something went wrong',
      message: i18n.modalErrorMessage || 'Please try again later.',
      detail,
      ctaText: i18n.modalTryAgain || 'Try again'
    });
  };
})();
